// Loaders
import { BaseWorkerLoader } from "../../base/loaders/BaseWorkerLoader";
/**
 * Loader class for loading workers in the teams app
 */
export class TeamsWorkerLoader extends BaseWorkerLoader {
}
